import '../App.css';
import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';

function Analytics() {
  return (
    <div>
      <Navigation />
      <h2>placeholder for opensearch</h2>
      <Footer />
    </div>
  );
}

export default Analytics;
